import {
    PersistentCounter,
    trackCategoryPageView,
    trackHomePageView,
    trackPageView,
    trackSearchPageView,
} from "tsi-common-react/src/utils/analytics";
import { onDOMContentLoaded } from "tsi-common-react/src/utils/events";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

onDOMContentLoaded.on(() => {
    // Track page view
    new PersistentCounter("pageCount").increment();

    // Track page type view
    const document = getDocument();
    if (!document) {
        return;
    }
    const trackEvent = document.body.dataset.trackEvent;
    switch (trackEvent) {
        case "HomePageView":
            trackHomePageView();
            break;

        case "SearchPageView":
            if (document.body.dataset.trackEventData) {
                try {
                    const trackEventData = JSON.parse(
                        document.body.dataset.trackEventData,
                    );
                    trackSearchPageView(trackEventData.PRODUCT_IDS);
                } catch {
                    console.debug("Malformed event data for SearchPageView");
                }
            } else {
                console.debug("Missing event data for SearchPageView");
            }
            break;

        case "CategoryPageView":
            if (document.body.dataset.trackEventData) {
                try {
                    const trackEventData = JSON.parse(
                        document.body.dataset.trackEventData,
                    );
                    trackCategoryPageView(trackEventData.PRODUCT_IDS);
                } catch {
                    console.debug("Malformed event data for CategoryPageView");
                }
            } else {
                console.debug("Missing event data for CategoryPageView");
            }
            break;

        case "ProductDisplayPageView":
        case "ProductLinePageView":
            new PersistentCounter("pdpCount").increment();
            break;
    }

    trackPageView().catch(() => {});
});
